"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import $ from "jquery";
import _ from "underscore";
import ApiService from "../services/api_service";
import Auth from "../util/auth";
class AlertArea extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "showAlert", (event, errorObject) => {
      this.setState({
        alertShowing: true,
        alertMessage: errorObject.message,
        alertDetails: errorObject.details ? _.extend(errorObject.details, { location: window.location }) : null,
        alertType: errorObject.type === void 0 ? "alert" : errorObject.type
      });
    });
    __publicField(this, "closeAlert", () => {
      this.setState({ alertShowing: false });
    });
    __publicField(this, "viewDetails", () => {
      this.setState({ viewingDetails: true });
    });
    this.state = {
      alertShowing: false
    };
  }
  componentDidMount() {
    $(ApiService).on("ApiService:alertError", this.showAlert);
  }
  componentWillUnmount() {
    $(ApiService).off("ApiService:alertError", this.showAlert);
  }
  errorText() {
    return "Please describe what you were doing above this line.\n----------------------------------\n\n" + btoa(JSON.stringify(this.state.alertDetails));
  }
  details() {
    if (this.state.viewingDetails) {
      const supportEmail = Auth._currentUser.account.settings.processor_support_email_address;
      const supportMessage = supportEmail ? "an email to" : "a support ticket at";
      const supportUrl = supportEmail ? `mailto:${supportEmail}` : "https://paymentshelp.triumph.io/support/tickets/new";
      const target = supportEmail ? void 0 : "_blank";
      const supportText = supportEmail ? supportEmail : "TriumphPay Support";
      return /* @__PURE__ */ jsxs("div", { className: "alert-box__error-details", children: [
        /* @__PURE__ */ jsx("h3", { children: "Error Details" }),
        /* @__PURE__ */ jsxs("p", { children: [
          "Copy and paste this information into ",
          supportMessage,
          " ",
          /* @__PURE__ */ jsx("a", { href: supportUrl, target, children: supportText }),
          ":"
        ] }),
        /* @__PURE__ */ jsx("textarea", { value: this.errorText(), rows: 12 })
      ] });
    }
  }
  notifySupportLink() {
    if (!this.state.viewingDetails && !_.isEmpty(this.state.alertDetails)) {
      return /* @__PURE__ */ jsx("a", { className: "alert-box__support-link", onClick: this.viewDetails, children: "View Details." });
    }
  }
  alertBox() {
    if (this.state.alertShowing) {
      return /* @__PURE__ */ jsx("div", { className: "app-alert-area alert-row row", children: /* @__PURE__ */ jsxs("div", { className: "alert-box " + this.state.alertType + " radius", children: [
        this.state.alertMessage,
        "\xA0",
        this.notifySupportLink(),
        this.details(),
        /* @__PURE__ */ jsx("a", { onClick: this.closeAlert, className: "close", children: /* @__PURE__ */ jsx("span", { className: "app-alert-area__close-text", children: "\xD7" }) })
      ] }) });
    }
  }
  render() {
    return /* @__PURE__ */ jsx("div", { id: "alert-area", "data-component": "AlertArea", children: this.alertBox() });
  }
}
export default AlertArea;
